<button (click)="goBack()" class="btn btn-lg btn-light">
  <i class="bi bi-arrow-left-short fs-4 me-md-2"></i> <span>{{ label }}</span>
</button>
